var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAbilityToBulkSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F7F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8682F8",
    d: "M17.4 16.1c-.5 0-1 .4-1.2.9l-.1.2v4.9h-4v2h4v2h-6V28h6v2H8v2h27c.4-.2.7-.6.8-.9l.1-.3V17.1c-.2-.5-.4-.6-.8-.9l-.3-.1H17.4M34 18.6v.5l-1.3.8a400 400 0 01-6.7 3.9l-1.3-.7a304.4 304.4 0 00-4-2.5L18 19.1v-1h16v.5m-13.8 4.2a336.3 336.3 0 004.2 2.5l.4.2a3 3 0 002 .1 149.8 149.8 0 007-4l.1-.1V30H18v-4.3c0-4 0-4.3.2-4.3l2 1.3"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iMjQiIGZpbGw9IiNGN0Y3RkYiLz4KICAgIDxwYXRoIGZpbGw9IiM4NjgyRjgiIGQ9Ik0xNy40IDE2LjFjLS41IDAtMSAuNC0xLjIuOWwtLjEuMnY0LjloLTR2Mmg0djJoLTZWMjhoNnYySDh2MmgyN2MuNC0uMi43LS42LjgtLjlsLjEtLjN2LTYuNy03Yy0uMi0uNS0uNC0uNi0uOC0uOWwtLjMtLjFIMTcuNE0zNCAxOC42di41bC0xLjMuOGE0MDAgNDAwIDAgMDEtNi43IDMuOWwtMS4zLS43YTMwNC40IDMwNC40IDAgMDAtNC0yLjVMMTggMTkuMXYtMWgxNnYuNW0tMTMuOCA0LjJhMzM2LjMgMzM2LjMgMCAwMDQuMiAyLjVsLjQuMmEzIDMgMCAwMDIgLjEgMTQ5LjggMTQ5LjggMCAwMDctNGwuMS0uMVYzMEgxOHYtNC4zYzAtNCAwLTQuMy4yLTQuM2wyIDEuMyIvPgoKPC9zdmc+Cg==";
export { SvgAbilityToBulkSend as ReactComponent };